import { useState } from "react";
import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 34 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};

// Scroll reveal wrapper
export const Reveal = ({ children, className = "", delay = 0, y = 34, as = "div", ...rest }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

// Masked line-by-line reveal for hero
export const MaskLine = ({ children, delay = 0, className = "" }) => {
  const [revealComplete, setRevealComplete] = useState(false);

  return (
    <span className="line-mask block h-[1lh]" style={{ overflow: revealComplete ? "visible" : "hidden" }}>
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
        onAnimationComplete={() => setRevealComplete(true)}
      >
        {children}
      </motion.span>
    </span>
  );
};
